module.exports = __webpack_public_path__ + "03b18396b4aa82008cf614ffe4bff51d.png";